import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkFalabellaAccess } from '@/redux/parcel/asyncRequest';
import { AppDispatch, RootState } from '@/redux/store';

export const useFalabellaAccess = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { falabellaAccess } = useSelector((state: RootState) => state.parcel);
  const clientId = useSelector(
    (state: RootState) => state.parcel.profile.data?.credentials?.clientId,
  );

  useEffect(() => {
    if (clientId && !falabellaAccess.checked) {
      dispatch(checkFalabellaAccess());
    }
  }, [dispatch, clientId, falabellaAccess.checked]);

  return {
    hasFalabellaAccess: falabellaAccess.hasAccess,
    checked: falabellaAccess.checked,
  };
};
